<template>
  <div :class="['container', direction]">
    <div :class="['top', topBrandColor]">
      <div class="content">
        <slot name="top"></slot>
      </div>
    </div>
    <div :class="['bottom', bottomBrandColor]">
      <div class="content">
        <slot name="bottom"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default{
  name: 'split-container',
  props: {
    direction: String,
    topBrandColor: String,
    bottomBrandColor: String
  }
}
</script>

<style scoped lang="scss">
/** split-container **/
@import '../theme';

.container {
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @include media-breakpoint-up(lg) {
    height: 100vh;

  }
}

.top,
.bottom {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  &.white {
    background-color: zespri-brand-color(white);
  }

  &.green {
    background-color: zespri-brand-color(green);
  }

  &.yellow {
    background-color: zespri-brand-color(yellow);
  }
  &.light-gray {
    background-color: zespri-brand-color(light-gray);
  }
}

.content {
  height: 100%;
  width: 100%;
}

.down {
  .top {
    @include curved-bottom-border;
    transform: scaleX(1.2);
    transform-origin: bottom;

    .content {
      transform: scaleX(0.8);
    }
  }

  .bottom {
    z-index: zespri-layer(normal);
  }
}

.up {
  .top {
    z-index: zespri-layer(normal);
  }

  .bottom {
    @include curved-top-border;
    transform: scaleX(1.2);

    .content {
      transform: scaleX(0.8);
    }
  }
}
</style>
